// WordPressPlugin.js
import React, { useEffect } from "react";

// 1. Import the FontAwesomeIcon component and the specific icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDownload, 
  faCloudArrowUp, 
  faFileZipper, 
  faPowerOff, 
  faGear, 
  faPaste, 
  faCircleCheck,
  faRocket
} from '@fortawesome/free-solid-svg-icons';

export default function WordPressPlugin() {
  useEffect(() => {
    document.title = "WordPress Plugin | KlonIT Web Application";
  }, []);

  return (
    <div>
      <main className="content">
        <div className="container-fluid p-0">
          <h1 className="h3 mb-3">
            <strong>WordPress Plugin Installation</strong>
          </h1>

          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Installation Guide</h5>
            </div>
            <div className="card-body">
              <p className="lead">
                Follow these steps to integrate your KlonIT chatbot with your WordPress website in just a few minutes.
              </p>

              {/* Step 1: Download Button */}
              <div className="text-center my-4">
                <a 
                  href="https://klonit.ai/downloads/wordpress-plugin/klonit-chatbot.zip" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-lg"
                >
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Download KlonIT Plugin (.zip)
                </a>
              </div>

              <hr />

              <h5 className="mt-4">Installation Steps</h5>

              {/* Step 2-7: Installation and Activation Steps */}
              <ol className="list-group list-group-flush">
                <li className="list-group-item d-flex align-items-center">
                  <FontAwesomeIcon icon={faCloudArrowUp} className="fs-4 me-3 text-muted" fixedWidth />
                  <div>
                    In your WordPress admin dashboard, navigate to <strong>Plugins > Add Plugin</strong> and click the <strong>Browse</strong> button.
                  </div>
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <FontAwesomeIcon icon={faFileZipper} className="fs-4 me-3 text-muted" fixedWidth />
                  <div>
                    <strong>Choose</strong> the <code>klonit-chatbot.zip</code> file you just downloaded and click <strong>Install Now</strong>.
                  </div>
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <FontAwesomeIcon icon={faPowerOff} className="fs-4 me-3 text-muted" fixedWidth />
                  <div>
                    Once the installation is complete, click the <strong>Activate Plugin</strong> button.
                  </div>
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <FontAwesomeIcon icon={faGear} className="fs-4 me-3 text-muted" fixedWidth />
                  <div>
                    Navigate to the plugin settings page via <strong>Settings > KlonIT Chatbot</strong> in your WordPress menu.
                  </div>
                </li>
                <li className="list-group-item d-flex align-items-center">
                  <FontAwesomeIcon icon={faPaste} className="fs-4 me-3 text-muted" fixedWidth />
                  <div>
                    From your KlonIT Dashboard, copy your unique chatbot <strong>Script Snippet</strong> and paste it into the provided text area on the plugin's settings page.
                  </div>
                </li>
                 <li className="list-group-item d-flex align-items-center">
                  <FontAwesomeIcon icon={faCircleCheck} className="fs-4 me-3 text-success" fixedWidth />
                  <div>
                    Click <strong>Save Changes</strong>. Your chatbot is now configured!
                  </div>
                </li>
              </ol>

              {/* Step 8: Final Confirmation */}
              <div className="alert alert-success mt-4" role="alert">
                <div className="d-flex">
                  <div className="alert-icon">
                    <FontAwesomeIcon icon={faRocket} className="fs-2 me-3" />
                  </div>
                  <div>
                    <h4 className="alert-heading">All Set!</h4>
                    <p className="mb-0">
                      Your KlonIT chatbot should now be visible on your WordPress website. If you don't see it immediately, try clearing your website's cache or opening your site in a private/incognito browser window.
                    </p>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}